import { useQuery } from '@tanstack/react-query'
import { getLabCampaignPreview } from 'api/labV2'
import { LAB_CAMPAIGN_PREVIEW_QUERY_PARAM } from 'constants/lab'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function useLabUiPreview() {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const id = params.get(LAB_CAMPAIGN_PREVIEW_QUERY_PARAM) ?? undefined
  const { data, isError } = useQuery({
    queryKey: ['lab-campaign-preview', id],
    queryFn: ({ signal }) => getLabCampaignPreview(id ?? '', signal),
    enabled: typeof window !== 'undefined' && !!id,
    retry: false,
    staleTime: 30000,
    refetchOnWindowFocus: false,
  })
  const items = useMemo(() => isError ? [] : data ?? [], [data, isError])
  return { id, items }
}
